import BaseModelAPI from '../BaseModelAPI';

export default class VendorScrap extends BaseModelAPI {
	static entity = '';
	static entityName = 'vendorscrap';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.code = '';
			this.name = '';
			this.address = '';
			this.contactPerson = '';
			this.contactPersonPhoneNumber = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}